import Curl from '$common/utils/curl/browser-curl';
import AppCurl from '$common/utils/curl/app-curl';
import UrlModules from '$common/utils/curl/browser-curl/url-modules';
import { gateway_web as pix } from './api-pix';
const appgatewayHost = new UrlModules({ module: 'appgateway' });
export const defaultCurl = (params, url, config) => new Curl().curl(params, `${appgatewayHost.host}/${pix}/${url}`, config);
const defaultAppCurl = (params, url, config) => new AppCurl().curl(params, `/${url}`, config);
//  封装统一的请求
export const curlGateWay = (params, url, config) => (!!window?.$vm?.$root?.global?.isWOWNOW) ? defaultAppCurl(params, url, config) : defaultCurl(params, url, config);

export const appCurl = (params, url, config) => defaultAppCurl(params, url, config);
